import basic_month_table_vue_vue_type_script_setup_true_lang_default from "./basic-month-table.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/date-picker-panel/src/date-picker-com/basic-month-table.vue
var basic_month_table_default = basic_month_table_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { basic_month_table_default as default };
//# sourceMappingURL=basic-month-table.mjs.map